var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'row-container',
    _vm.blockWidthClass,
    {
      'contains-cover-image': _vm.containsCoverImage,
    } ]},_vm._l((_vm.cells),function(cell){return _c('EditorCell',{key:cell.id,attrs:{"nodes":cell.nodes,"cell-width":cell.width,"merge-values":_vm.mergeValues,"is-pdf-viewer":_vm.isPdfViewer,"block-width-class":_vm.blockWidthClass,"page-width":_vm.pageWidth,"is-block-toggled":_vm.isBlockToggled}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }